// Copyright 2023-2024 dev.mimir authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Do not edit, auto-generated by @mimirdev/dev

export const packageInfo = {
  name: '@mimirdev/apps-inject',
  path: 'auto',
  type: 'auto',
  version: '1.0.2'
};